import { useState, useEffect, useRef, useMemo } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box, Typography, Paper } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Popper from "@mui/material/Popper";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import "react-multi-carousel/lib/styles.css";
import LoaderDialog from "../../ui/loader/Loader";
import Snackbar from "@mui/material/Snackbar";
import {
  fetchTipoParametrosTrabajo,
  fetchFasesTrabajo,
  fetchCategoriaNombreImagen,
  cambiarOrdenTipoParametrosTrabajo,
  cambiarOrdenCategoriaNombreImagen,
  deleteTipoParametrosTrabajo,
  deleteCategoriaNombreImagen,
  getCategoriasReportes,
  deleteCategoriaReporte,
  cambiarOrdenCategoriasReportes,
} from "../../components/functions/Projects";
import ConfirmDialog from "../../features/imagenesModal/dialogs/ConfirmDialog";
import CustomButton from "../../ui/button/Button";
import EDTCategoriaImagenModal from "./EDTCategoriaImagenModal";
import EDTParametroModal from "./EDTParametroModal";
import EDTCategoriaReporteModal from "./EDTCategoriaReporteModal";

const EDTModal = ({ open, onClose, selectedEDT, API_URL, user }) => {
  const [fasesDeTrabajo, setFasesDeTrabajo] = useState([]);
  const [parametros, setParametros] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriasReportes, setCategoriasReportes] = useState([]);
  const [selectedFaseDeTrabajo, setSelectedFaseDeTrabajo] = useState(null);
  const [selectedType, setSelectedType] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [openMenuIndex2, setOpenMenuIndex2] = useState(null);
  const [openMenuIndex3, setOpenMenuIndex3] = useState(null);
  const [showConfirm, setShowConfirm] = useState({
    show: false,
    title: "",
    content: "",
    type: "",
  });
  const [data, setData] = useState([]);

  const [openCategoriaModal, setOpenCategoriaModal] = useState(false);
  const [openParametroModal, setOpenParametroModal] = useState(false);
  const [openCategoriaReporteModal, setOpenCategoriaReporteModal] =
    useState(false);

  const [selectedCategoria, setSelectedCategoria] = useState(null);
  const [selectedCategoriaReporte, setSelectedCategoriaReporte] =
    useState(null);
  const [selectedParametro, setSelectedParametro] = useState(null);

  const [isEdit, setIsEdit] = useState(false);

  const columnsParametros = useMemo(
    () => [
      { accessorKey: "orden", header: "Orden", size: 10 },
      { accessorKey: "nombre", header: "Nombre", size: 50 },
      { accessorKey: "tipoParametro.descripcion", header: "Tipo", size: 50 },
      {
        accessorKey: "categoriaReporte.nombre",
        header: "Categoría de reporte",
        size: 50,
      },
      {
        accessorKey: "acciones",
        header: "Acciones",
        size: 40,
        Cell: ({ row }) => {
          const anchorRef = useRef(null);
          const isOpen = openMenuIndex === row.index;
          return (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <button
                ref={anchorRef}
                onClick={() => {
                  setOpenMenuIndex((prev) =>
                    prev === row.index ? null : row.index
                  );
                  setSelectedParametro(row.original);
                }}
                className="action-icon"
              >
                <img
                  src={Ajustes}
                  alt="Ajustes"
                  style={{ width: 20, height: 20 }}
                />
              </button>

              <Popper
                open={isOpen}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                style={{ zIndex: 9999999 }}
              >
                <div
                  className="dropdown-menu-user"
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    marginTop: 5,
                    padding: 5,
                    minWidth: 100,
                  }}
                >
                  {user && user.perfil && user.perfil.esAdministrador && (
                    <p
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        padding: "5px 10px",
                      }}
                      onClick={() => {
                        setIsEdit(true);
                        // setSelectedParametro(row.original);
                        setOpenParametroModal(true);
                        setOpenMenuIndex(null);
                      }}
                    >
                      <img
                        src={Editar}
                        alt=""
                        style={{ width: 16, height: 16, marginRight: 8 }}
                      />
                      Editar
                    </p>
                  )}

                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setShowConfirm({
                        show: true,
                        title: "Confirmación",
                        content:
                          "¿Estás seguro que deseas eliminar el parámetro?",
                        type: "eliminarParametro",
                      });
                      setOpenMenuIndex(null);
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    Borrar
                  </p>
                </div>
              </Popper>
            </div>
          );
        },
      },
    ],
    [openMenuIndex]
  );

  const columnsCategoriasMemo = useMemo(
    () => [
      { accessorKey: "orden", header: "Orden", size: 10 },
      { accessorKey: "nombre", header: "Nombre", size: 50 },
      {
        accessorKey: "categoriaReporteNombre",
        header: "Categoría de reporte",
        size: 50,
      },
      {
        accessorKey: "acciones",
        header: "Acciones",
        size: 40,
        Cell: ({ row }) => {
          const anchorRef = useRef(null);
          const isOpen = openMenuIndex2 === row.index;
          return (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <button
                ref={anchorRef}
                onClick={() => {
                  setOpenMenuIndex2((prev) =>
                    prev === row.index ? null : row.index
                  );
                  setSelectedCategoria(row.original);
                }}
                className="action-icon"
              >
                <img
                  src={Ajustes}
                  alt="Ajustes"
                  style={{ width: 20, height: 20 }}
                />
              </button>
              <Popper
                open={isOpen}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                style={{ zIndex: 9999 }}
              >
                <div
                  className="dropdown-menu-user"
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    marginTop: 5,
                    padding: 5,
                    minWidth: 100,
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setIsEdit(true);
                      // setSelectedCategoria(row.original);
                      setOpenCategoriaModal(true);
                      setOpenMenuIndex2(null);
                    }}
                  >
                    <img
                      src={Editar}
                      alt=""
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    Editar
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setShowConfirm({
                        show: true,
                        title: "Confirmación",
                        content:
                          "¿Estás seguro que deseas eliminar la categoría?",
                        type: "eliminarCategoria",
                      });
                      setOpenMenuIndex2(null);
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    Borrar
                  </p>
                </div>
              </Popper>
            </div>
          );
        },
      },
    ],
    [openMenuIndex2]
  );

  const columnsCategoriasReporteMemo = useMemo(
    () => [
      { accessorKey: "orden", header: "Orden", size: 10 },
      { accessorKey: "nombre", header: "Nombre", size: 50 },
      {
        accessorKey: "descripcion",
        header: "Descripción",
        size: 50,
      },
      {
        accessorKey: "acciones",
        header: "Acciones",
        size: 40,
        Cell: ({ row }) => {
          const anchorRef = useRef(null);
          const isOpen = openMenuIndex3 === row.index;
          return (
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <button
                ref={anchorRef}
                onClick={() => {
                  setOpenMenuIndex3((prev) =>
                    prev === row.index ? null : row.index
                  );
                  setSelectedCategoriaReporte(row.original);
                }}
                className="action-icon"
              >
                <img
                  src={Ajustes}
                  alt="Ajustes"
                  style={{ width: 20, height: 20 }}
                />
              </button>
              <Popper
                open={isOpen}
                anchorEl={anchorRef.current}
                placement="bottom-start"
                style={{ zIndex: 9999 }}
              >
                <div
                  className="dropdown-menu-user"
                  style={{
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: 4,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    marginTop: 5,
                    padding: 5,
                    minWidth: 100,
                  }}
                >
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setIsEdit(true);
                      setOpenCategoriaReporteModal(true);
                      setOpenMenuIndex3(null);
                    }}
                  >
                    <img
                      src={Editar}
                      alt=""
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    Editar
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      padding: "5px 10px",
                    }}
                    onClick={() => {
                      setShowConfirm({
                        show: true,
                        title: "Confirmación",
                        content:
                          "¿Estás seguro que deseas eliminar la categoría de reporte?",
                        type: "eliminarCategoriaReporte",
                      });
                      setOpenMenuIndex3(null);
                    }}
                  >
                    <img
                      src={Eliminar}
                      alt=""
                      style={{ width: 16, height: 16, marginRight: 8 }}
                    />
                    Borrar
                  </p>
                </div>
              </Popper>
            </div>
          );
        },
      },
    ],
    [openMenuIndex3]
  );

  const columnsToUse =
    selectedType === 1
      ? columnsParametros
      : selectedType === 2
      ? columnsCategoriasMemo
      : columnsCategoriasReporteMemo;

  useEffect(() => {
    const fetchFasesDeTrabajo = async () => {
      try {
        const response = await fetchFasesTrabajo(API_URL, selectedEDT.id);
        response.forEach((fase) => {
          if (fase.descripcion === "Entregable") {
            fase.descripcion = "Implementación";
          }
        });
        setFasesDeTrabajo(response);
        if (response && response.length > 0) {
          setSelectedFaseDeTrabajo((prev) => response[0]);
        }
      } catch (error) {
        console.error("Error fetching fases de trabajo:", error);
      }
    };
    if (selectedEDT && open) {
      fetchFasesDeTrabajo();
    }
    // eslint-disable-next-line
  }, [selectedEDT]);

  useEffect(() => {
    const fetchParametros = async () => {
      try {
        setShowLoader(true);
        if (selectedType === 1) {
          const response = await fetchTipoParametrosTrabajo(
            API_URL,
            selectedEDT.id,
            selectedFaseDeTrabajo?.name
          );
          setParametros([...response]);
          setData([...response]);
          setOpenMenuIndex(null);
          setOpenMenuIndex2(null);
        } else if (selectedType === 2) {
          const response = await fetchCategoriaNombreImagen(
            API_URL,
            selectedEDT.id,
            selectedFaseDeTrabajo?.name
          );
          setCategorias([...response]);
          setData([...response]);
          setOpenMenuIndex(null);
          setOpenMenuIndex2(null);
        } else if (selectedType === 3) {
          const response = await getCategoriasReportes(API_URL, selectedEDT.id);
          setCategoriasReportes([...response]);
          setData([...response]);
          setOpenMenuIndex(null);
          setOpenMenuIndex2(null);
        }
        setShowLoader(false);
      } catch (error) {
        setShowLoader(false);
        console.error("Error fetching parametros:", error);
      }
    };
    if (selectedFaseDeTrabajo && selectedEDT) {
      fetchParametros();
    }
    // eslint-disable-next-line
  }, [selectedType, selectedFaseDeTrabajo]);

  const handleCategoriaModalClose = async () => {
    setOpenCategoriaModal(false);
    setSelectedCategoria(null);
    setIsEdit(false);

    if (selectedType === 2) {
      const response = await fetchCategoriaNombreImagen(
        API_URL,
        selectedEDT.id,
        selectedFaseDeTrabajo?.name
      );
      setCategorias([...response]);
      setData([...response]);
    }
  };

  const handleCategoriaReporteModalClose = async () => {
    setOpenCategoriaReporteModal(false);
    setSelectedCategoriaReporte(null);
    setIsEdit(false);
    if (selectedType === 3) {
      const response = await getCategoriasReportes(API_URL, selectedEDT.id);
      setCategoriasReportes([...response]);
      setData([...response]);
    }
  };

  const handleParametroModalClose = async () => {
    setOpenParametroModal(false);
    setSelectedParametro(null);
    setIsEdit(false);

    if (selectedType === 1) {
      const response = await fetchTipoParametrosTrabajo(
        API_URL,
        selectedEDT.id,
        selectedFaseDeTrabajo?.name
      );
      setParametros([...response]);
      setData([...response]);
    }
  };

  const handleDeleteParametro = async () => {
    try {
      setShowLoader(true);
      await deleteTipoParametrosTrabajo(API_URL, selectedParametro.id);
      setParametros((prev) =>
        prev.filter((p) => p.id !== selectedParametro.id)
      );
      setData((prev) => prev.filter((p) => p.id !== selectedParametro.id));
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Parámetro eliminado correctamente");
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Error al eliminar el parámetro");
    }
  };

  const handleDeleteCategoria = async () => {
    try {
      setShowLoader(true);
      await deleteCategoriaNombreImagen(API_URL, selectedCategoria.id);
      setCategorias((prev) =>
        prev.filter((c) => c.id !== selectedCategoria.id)
      );
      setData((prev) => prev.filter((c) => c.id !== selectedCategoria.id));
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Categoría eliminada correctamente");
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Error al eliminar la categoría");
    }
  };

  const handleDeleteCategoriaReporte = async () => {
    try {
      setShowLoader(true);
      await deleteCategoriaReporte(API_URL, selectedCategoriaReporte.id);
      setCategoriasReportes((prev) =>
        prev.filter((c) => c.id !== selectedCategoriaReporte.id)
      );
      setData((prev) =>
        prev.filter((c) => c.id !== selectedCategoriaReporte.id)
      );
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Categoría de reporte eliminada correctamente");
    } catch (error) {
      setShowLoader(false);
      setShowSnackbar(true);
      setSnackbarMessage("Error al eliminar la categoría de reporte");
    }
  };

  const guardarCambios = async () => {
    setShowLoader(true);
    try {
      if (selectedType === 1) {
        await cambiarOrdenTipoParametrosTrabajo(API_URL, data);
        setParametros([...data]);
      } else if (selectedType === 2) {
        await cambiarOrdenCategoriaNombreImagen(API_URL, data);
        setCategorias([...data]);
      } else if (selectedType === 3) {
        const payload = {
          categoriaReportes: data,
        };
        await cambiarOrdenCategoriasReportes(API_URL, payload);
        setCategoriasReportes([...data]);
      }
      setShowLoader(false);
      setSnackbarMessage("Cambios guardados correctamente");
      setShowSnackbar(true);
    } catch (error) {
      setShowLoader(false);
      setSnackbarMessage("Error al guardar los cambios");
      setShowSnackbar(true);
    }
  };

  const restaurarCambios = () => {
    if (selectedType === 1) {
      setData([...parametros]);
    } else if (selectedType === 2) {
      setData([...categorias]);
    } else if (selectedType === 3) {
      setData([...categoriasReportes]);
    }
    setSnackbarMessage("Cambios restaurados");
    setShowSnackbar(true);
  };

  const handleClose = () => {
    setSelectedFaseDeTrabajo(null);
    setParametros([]);
    setSelectedType(1);
    setOpenMenuIndex(null);
    setOpenMenuIndex2(null);
    setFasesDeTrabajo([]);
    setData([]);
    setSnackbarMessage("");
    setShowSnackbar(false);
    setShowLoader(false);
    setShowConfirm({
      show: false,
      title: "",
      content: "",
      type: "",
    });
    onClose();
  };

  const table = useMaterialReactTable({
    autoResetPageIndex: false,
    columns: columnsToUse,
    data,
    enableRowOrdering: true,
    enableSorting: false,
    enableFilters: false,
    enableTopToolbar: false,
    enableColumnActions: false,
    getRowId: (originalRow) => originalRow.id,
    positionToolbarAlertBanner: "none",
    localization: MRT_Localization_ES,
    layoutMode: "grid",
    defaultColumn: {
      minSize: 40,
      size: 80,
    },
    muiRowDragHandleProps: ({ table }) => ({
      onDragEnd: () => {
        const { draggingRow, hoveredRow } = table.getState();
        if (hoveredRow && draggingRow) {
          data.splice(
            hoveredRow.index,
            0,
            data.splice(draggingRow.index, 1)[0]
          );
          setData([...data]);
        }
      },
    }),
  });

  return (
    <>
      <EDTCategoriaImagenModal
        selectedEDT={selectedEDT}
        API_URL={API_URL}
        open={openCategoriaModal}
        handleClose={handleCategoriaModalClose}
        categoria={selectedCategoria}
        edit={isEdit}
        selectedFaseDeTrabajo={selectedFaseDeTrabajo}
      />
      <EDTCategoriaReporteModal
        selectedEDT={selectedEDT}
        API_URL={API_URL}
        open={openCategoriaReporteModal}
        handleClose={handleCategoriaReporteModalClose}
        categoria={selectedCategoriaReporte}
        edit={isEdit}
      />
      <EDTParametroModal
        selectedEDT={selectedEDT}
        API_URL={API_URL}
        open={openParametroModal}
        handleClose={handleParametroModalClose}
        parametro={selectedParametro}
        edit={isEdit}
        selectedFaseDeTrabajo={selectedFaseDeTrabajo}
      />
      <Dialog
        fullWidth={true}
        maxWidth={false}
        onClose={handleClose}
        open={open}
        disableEnforceFocus
      >
        <Snackbar
          open={showSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setShowSnackbar(false);
            setSnackbarMessage("");
          }}
          message={snackbarMessage}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          slotProps={{
            content: {
              sx: {
                backgroundColor: "white",
                color: "#222",
                justifyContent: "center",
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "16px",
                fontFamily: "Roboto, Arial, sans-serif",
              },
            },
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            minHeight: "70vh",
          }}
        >
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                height: "50px",
                padding: "20px",
              }}
            >
              <Typography sx={{ fontSize: "18px" }} align="left">
                {selectedEDT?.nombre || "Estructura de Desglose de Trabajo"}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                  position: "absolute",
                  right: 0,
                  top: 6,
                  color: theme.palette.grey[500],
                })}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              <Tabs
                variant="fullWidth"
                value={selectedType}
                onChange={(e, value) => setSelectedType(value)}
              >
                <Tab label="Parámetros" value={1} />
                <Tab label="Categoría nombre imagen" value={2} />
                <Tab label="Categorías de reporte" value={3} />
              </Tabs>
              {fasesDeTrabajo &&
                fasesDeTrabajo.length > 0 &&
                selectedType !== 3 && (
                  <Tabs
                    variant="fullWidth"
                    value={selectedFaseDeTrabajo.descripcion || null}
                    onChange={(e, value) =>
                      setSelectedFaseDeTrabajo(
                        fasesDeTrabajo.find((c) => c.descripcion === value)
                      )
                    }
                  >
                    {fasesDeTrabajo &&
                      fasesDeTrabajo.length > 0 &&
                      fasesDeTrabajo.map((fase) => (
                        <Tab
                          label={fase.descripcion}
                          value={fase.descripcion}
                          key={fase.descripcion}
                        />
                      ))}
                  </Tabs>
                )}
            </Box>
            <Box sx={{ padding: "20px 20px 0", display: "flex", gap: "20px" }}>
              <CustomButton
                background={"#223D51"}
                color={"#FFFFFF"}
                text="Agregar categoría de imagen"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() => {
                  setOpenCategoriaModal(true);
                }}
                type="button"
              />
              {user && user.perfil && user.perfil.esAdministrador && (
                <CustomButton
                  background={"#223D51"}
                  color={"#FFFFFF"}
                  text="Agregar categoría de reporte"
                  width="210px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenCategoriaReporteModal(true);
                  }}
                  type="button"
                />
              )}

              {user && user.perfil && user.perfil.esAdministrador && (
                <CustomButton
                  background={"#223D51"}
                  color={"#FFFFFF"}
                  text="Agregar parámetro"
                  width="150px"
                  height="40px"
                  fontWeight="700"
                  fontSize="14px"
                  border="1px solid #D9D9D9"
                  onClick={() => {
                    setOpenParametroModal(true);
                  }}
                  type="button"
                />
              )}

              <CustomButton
                background={"#FFFFFF"}
                color={"#223D51"}
                text="Restaurar orden"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={restaurarCambios}
                type="button"
              />
              <CustomButton
                background={"#223D51"}
                color={"#FFFFFF"}
                text="Guardar orden"
                width="150px"
                height="40px"
                fontWeight="700"
                fontSize="14px"
                border="1px solid #D9D9D9"
                onClick={() =>
                  setShowConfirm({
                    show: true,
                    title: "Confirmación",
                    content:
                      "¿Seguro que desea cambiar el orden de estos datos?",
                    type: "cambiarOrden",
                  })
                }
                type="button"
              />
            </Box>
            <Box sx={{ padding: "20px" }}>
              <Paper sx={{ width: "100%" }}>
                <MaterialReactTable table={table} />
              </Paper>
            </Box>
          </Box>
        </div>
      </Dialog>
      <ConfirmDialog
        open={showConfirm.show}
        title={showConfirm.title}
        content={showConfirm.content}
        onClose={() => {
          setShowConfirm({
            show: false,
            title: "",
            content: "",
            type: "",
          });
          setOpenMenuIndex(null);
          setOpenMenuIndex2(null);
          setSelectedParametro(null);
          setSelectedCategoria(null);
        }}
        onConfirm={() => {
          if (showConfirm.type === "cambiarOrden") {
            guardarCambios();
          } else if (showConfirm.type === "eliminarParametro") {
            handleDeleteParametro();
          } else if (showConfirm.type === "eliminarCategoria") {
            handleDeleteCategoria();
          } else if (showConfirm.type === "eliminarCategoriaReporte") {
            handleDeleteCategoriaReporte();
          }

          setShowConfirm({
            show: false,
            title: "",
            content: "",
            type: "",
          });
        }}
      />

      <LoaderDialog open={showLoader} />
    </>
  );
};

export default EDTModal;
